export const classes = {
  wrapper: 'flex flex-col items-center',
};

export const FINANCIAL_STATEMENTS = [
  {
    name: '2025 Financial Statements',
    href: 'https://condor-investors-content.s3.eu-central-1.amazonaws.com/jaarrekening/Jaarrekening+Boekjaar+2025.pdf',
  },
  {
    name: '2024 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2024.pdf',
  },
  {
    name: '2023 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2023.pdf',
  },
  {
    name: '2022 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2022.pdf',
  },
  {
    name: '2021 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2021.pdf',
  },
  {
    name: '2020 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2020.pdf',
  },
  {
    name: '2019 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2019.pdf',
  },
  {
    name: '2018 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2018.pdf',
  },
  {
    name: '2017 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2017.pdf',
  },
  {
    name: '2016 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2016.pdf',
  },
  {
    name: '2015 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2015.pdf',
  },
  {
    name: '2014 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2014.pdf',
  },
  {
    name: '2013 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2013.pdf',
  },
  {
    name: '2012 Financial Statements',
    href: 'https://s3.eu-central-1.amazonaws.com/condor-investors-content/jaarrekening/Jaarrekening+Boekjaar+2012.pdf',
  },
];
